import React, { useRef, useState } from "react";
import Cropper, { ReactCropperElement } from "react-cropper";
import "cropperjs/dist/cropper.css";
import { Box } from "@mui/material";
import AppButton from "../component/base/AppButton.component";

const ImageCropper = ({ image, onCropDone, onCropCancel }) => {
  const cropperRef = useRef(null);
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const onCrop = () => {
    const cropper = cropperRef.current?.cropper;
    console.log(cropper.getCroppedCanvas().toDataURL());
    setCrop(cropper.getCroppedCanvas().toDataURL());
  };
  console.log("crop", crop);
  return (
    <Box
      display={"flex"}
      flexDirection={"column"}
      justifyContent={"flex-end"}
      alignItems={"end"}
      // alignSelf={"center"}
      minHeight={400}
    >
      <Box
        display={"flex"}
        flexDirection={"row"}
        mt={2}
        gap={15}
        justifyContent={"space-between"}
        width={"100%"}
        height={"100%"}
      >
        <Cropper
          src={image}
          style={{ height: "100%", width: "100%", minHeight: 400 }}
          initialAspectRatio={5 / 2}
          guides={false}
          crop={onCrop}
          ref={cropperRef}
          aspectRatio={5 / 2}
        />
      </Box>
      <Box display={"flex"} flexDirection={"row"} mt={2} gap={5}>
        <AppButton
          clickHandler={onCropCancel}
          buttonText="Cancel"
          variant={"text"}
        />
        <AppButton
          buttonText="Done"
          clickHandler={() => {
            onCropDone(crop);
          }}
        ></AppButton>
      </Box>
    </Box>
  );
};
export default ImageCropper;
